import Access from '../content/Access'
import IconCard from '../presentation/IconCard'
import { Artwork } from '@eggplant/pattern-library'
import {
  LinkToManageUsers,
  useDaiAccess
} from '@eggplant/routing'

const AccessIntro = () => {
  const [isAdmin] = useDaiAccess(['dai:admin'])

  return (
    <IconCard
      artwork={<Artwork.Lock />}
      title='Access'
    >
      <Access />
      <br />
      {
        isAdmin &&
          <LinkToManageUsers>
            Manage Users
          </LinkToManageUsers>
      }
    </IconCard>
  )
}

export default AccessIntro
